import { buildLocalizedOfferContent } from '../appRouteOfferCore.js';
import APP_ROUTE_OFFER_COPY_BN from './appRouteOfferContent.bn.js';

// Only this locale's offer copy: appRouteSeo.js imports some of these
// content files into the shared client chunk.
const OFFER_CONTENT = buildLocalizedOfferContent(APP_ROUTE_OFFER_COPY_BN, 'bn');

export const APP_ROUTE_SEO_CONTENT_BN = {
  "/metadata": {
    "title": "Metadata Studio",
    "intro": [
      "একটি ফোকাসড ওয়ার্কফ্লোতে স্টক ফটো, ভেক্টর এবং ভিডিও কীওয়ার্ড, শিরোনাম এবং বর্ণনা তৈরি করুন। Stocktag দ্রুত রানের জন্য একটি ইমেজ-টু-কিওয়ার্ড টুল এবং উত্পাদন কাজের জন্য একটি সম্পূর্ণ মেটাডেটা স্টুডিও হিসাবে উভয়ই কাজ করে।",
      "সম্পদ আপলোড করুন, দ্রুত আউটপুট পর্যালোচনা করুন এবং আপনার পোর্টফোলিও জুড়ে ধারাবাহিকতা না হারিয়ে CSV/XMP রপ্তানি করুন৷"
    ],
    "bullets": [
      "ইমেজ-টু-কীওয়ার্ড, শিরোনাম, এবং বর্ণনা ওয়ার্কফ্লো এক পাসে",
      "ডুপ্লিকেট এবং দুর্বল ট্যাগ পরিষ্কার করার জন্য দ্রুত পর্যালোচনা সরঞ্জাম",
      "প্রধান স্টক প্ল্যাটফর্মের জন্য রপ্তানি-প্রস্তুত আউটপুট"
    ],
    "links": [
      {
        "href": "/pricing",
        "label": "মূল্য পরিকল্পনা দেখুন"
      },
      {
        "href": "/blog",
        "label": "মেটাডেটা ব্লগ পড়ুন"
      },
      {
        "href": "/free-credits",
        "label": "বিনামূল্যে ক্রেডিট পান"
      }
    ],
    "sections": [
      {
        "title": "এক নজরে কর্মপ্রবাহ",
        "paragraphs": [
          "একটি ব্যাচ আপলোড করুন, শিরোনাম, বিবরণ এবং কীওয়ার্ডগুলি এক দৌড়ে তৈরি করুন, তারপর ফাইলের প্রসঙ্গ না হারিয়ে পর্যালোচনা করুন এবং রপ্তানি করুন৷"
        ],
        "bullets": [
          "পরিষ্কার ফাইলের নাম সহ ব্যাচগুলি আপলোড এবং প্রক্রিয়া করুন",
          "কীওয়ার্ড অর্ডার, শিরোনাম শব্দ এবং দুর্বল ট্যাগ পর্যালোচনা করুন",
          "মার্কেটপ্লেস আপলোডের জন্য CSV বা XMP রপ্তানি করুন"
        ]
      },
      {
        "title": "এটা কার জন্য",
        "paragraphs": [
          "অবদানকারী, স্টুডিও এবং দলগুলির জন্য ডিজাইন করা হয়েছে যারা স্কেলে প্রকাশ করে এবং মার্কেটপ্লেস জুড়ে একটি নির্ভরযোগ্য স্টক শিরোনাম-এবং-কীওয়ার্ড ওয়ার্কফ্লো প্রয়োজন।"
        ],
        "bullets": [
          "বড় লাইব্রেরি পরিচালনা করছেন নির্মাতারা",
          "যে দলগুলির পুনরাবৃত্তিযোগ্য মেটাডেটা নিয়ম প্রয়োজন",
          "একাধিক সাইটে পোর্টফোলিও প্রকাশ করা"
        ]
      }
    ],
    "faq": [
      OFFER_CONTENT.creditUsageFaq,
      {
        "q": "কোন মার্কেটপ্লেস সমর্থিত?",
        "a": "প্রধান স্টক প্ল্যাটফর্ম যেমন Adobe Stock, Shutterstock, Pond5, Getty এবং আরও অনেক কিছু সমর্থিত।"
      }
    ]
  },
  "/market-intelligence": {
    "title": "Market Intelligence",
    "intro": [
      "শুট বা ডিজাইনের আগে স্টক কীওয়ার্ডের ট্রেন্ড ও মৌসুমি চাহিদা যাচাই করুন। Trends Radar পড়ে Google-এর ফলাফল ও সাজেশন এবং Adobe Stock, Shutterstock-এর মতো স্টক সাইটের সার্চ ফলাফল।",
      "আরও পরিষ্কার অনুসন্ধানের অভিপ্রায় সহ দ্রুত প্রকাশ এবং র‌্যাঙ্ক করতে Metadata Studio-এর সাথে অন্তর্দৃষ্টি যুক্ত করুন।"
    ],
    "bullets": [
      "ক্রেতা অনুসন্ধানে স্পট প্রবণতা পরিবর্তন",
      "মৌসুমী পরিকল্পনার জন্য একটি মাইক্রোস্টক ক্যালেন্ডার অনুসরণ করুন",
      "বিভাগ দ্বারা বিষয়বস্তু ফাঁক সনাক্ত করুন",
      "বাস্তব চাহিদা সংকেত সঙ্গে পরিকল্পনা উত্পাদন"
    ],
    "links": [
      {
        "href": "/metadata",
        "label": "Metadata Studio খুলুন"
      },
      {
        "href": "/pricing",
        "label": "পরিকল্পনা তুলনা করুন"
      },
      {
        "href": "/blog",
        "label": "ট্রেন্ড গাইড অন্বেষণ করুন"
      }
    ],
    "sections": [
      {
        "title": "আপনি শুটিং আগে চাহিদা খুঁজুন",
        "paragraphs": [
          "Trends Radar দেখায় কোনো বিষয়ে সার্চের আগ্রহ কোন দিকে যাচ্ছে; এর ভিত্তি Google-এর ফলাফল ও সাজেশন এবং স্টক সাইটের সার্চ ফলাফল। ফলে আরও স্পষ্ট চাহিদার সংকেত দেখে প্রোডাকশনের পরিকল্পনা করতে পারেন।"
        ],
        "bullets": [
          "ঋতু চাহিদা পরিবর্তন ট্র্যাক",
          "উচ্চ-উদ্দেশ্যের কীওয়ার্ড তাড়াতাড়ি চিহ্নিত করুন",
          "উত্পাদনের আগে ধারণাগুলি যাচাই করুন"
        ]
      },
      {
        "title": "অন্তর্দৃষ্টিগুলিকে মেটাডেটাতে পরিণত করুন",
        "paragraphs": [
          "কীওয়ার্ড সেট রিফ্রেশ করতে ট্রেন্ড সিগন্যাল এবং ক্যালেন্ডার প্ল্যানিং ব্যবহার করুন এবং আসল ক্রেতার অভিপ্রায়ের সাথে শিরোনাম এবং বিবরণ সারিবদ্ধ করুন।"
        ],
        "bullets": [
          "নতুন পদের সাথে পুরানো পোর্টফোলিও রিফ্রেশ করুন",
          "চাহিদা সংকেত সঙ্গে মেটাডেটা সারিবদ্ধ",
          "পুনঃব্যবহারযোগ্য টেমপ্লেটগুলির সাথে দ্রুত শিপ করুন"
        ]
      }
    ],
    "faq": [
      {
        "q": "ট্রেন্ডের ডেটা কোথা থেকে আসে?",
        "a": "Trends Radar পাবলিক সার্চ সিগন্যাল থেকে চাহিদা অনুমান করে: কোনো বিষয়ের জন্য Google-এর ফলাফল ও সাজেশন, এবং Adobe Stock, Shutterstock, iStock ও Getty Images-এর মতো বড় স্টক সাইটের সার্চ ফলাফল। এটি কোনো মার্কেটপ্লেসের অভ্যন্তরীণ সার্চ ডেটা ব্যবহার করে না।"
      },
      {
        "q": "কত ঘন ঘন প্রবণতা আপডেট করা হয়?",
        "a": "নতুন চাহিদা সংকেত উপস্থিত হওয়ার সাথে সাথে ট্রেন্ড স্ন্যাপশটগুলি নিয়মিত রিফ্রেশ হয়৷"
      },
      {
        "q": "এটি কি একটি মাইক্রোস্টক ক্যালেন্ডার অন্তর্ভুক্ত করে?",
        "a": "হ্যাঁ। Market Intelligence ছুটির দিন এবং ঋতু পরিকল্পনা দৃশ্য অন্তর্ভুক্ত করে যাতে আপনি সঠিক উত্পাদন উইন্ডোতে কীওয়ার্ড সুযোগগুলি ম্যাপ করতে পারেন৷"
      },
      {
        "q": "এটি কি প্রতিটি পরিকল্পনায় অন্তর্ভুক্ত?",
        "a": "সাইন ইন করা সব অ্যাকাউন্টে Holiday Planner ব্যবহার করা যায়। Trends Radar ও Similarity Scanner মাসিক ক্রেডিট প্ল্যানে অন্তর্ভুক্ত।"
      }
    ]
  },
  "/free-credits": OFFER_CONTENT.freeCredits,
  "/image-generator": {
    "title": "Image Generator",
    "intro": [
      "স্টক ওয়ার্কফ্লো, কনসেপ্ট টেস্টিং এবং কীওয়ার্ড-টু-ইমেজ আইডিয়ার জন্য রেফারেন্স ভিজ্যুয়াল তৈরি করুন। দ্রুত অনুসন্ধান অভিপ্রায় যাচাই করতে মেটাডেটার সাথে ছবি আউটপুট যুক্ত করুন।",
      "আপনি শৈলী, রচনা এবং ব্যবহারের ক্ষেত্রে পরীক্ষা করার সময় আপনার উত্পাদন পাইপলাইন চলমান রাখুন।"
    ],
    "bullets": [
      "দ্রুত ধারণা বৈধতা",
      "কীওয়ার্ড-টু-ইমেজ আইডিয়া টেস্টিং",
      "স্টক প্রস্তুত সম্পদের জন্য শৈলী অন্বেষণ",
      "পরিকল্পনার জন্য কর্মপ্রবাহ-বান্ধব আউটপুট"
    ],
    "links": [
      {
        "href": "/metadata",
        "label": "মেটাডেটা তৈরি করুন"
      },
      {
        "href": "/pricing",
        "label": "পরিকল্পনা দেখুন"
      },
      {
        "href": "/blog",
        "label": "উত্পাদন টিপস পড়ুন"
      }
    ],
    "sections": [
      {
        "title": "স্টক পরিকল্পনা জন্য কেস ব্যবহার করুন",
        "paragraphs": [
          "সম্পূর্ণ শ্যুটের আগে রচনা, শৈলী, মৌসুমী ধারণা, বা প্রম্পট কীওয়ার্ড অন্বেষণ করতে দ্রুত ভিজ্যুয়াল রেফারেন্স তৈরি করুন।"
        ],
        "bullets": [
          "ধারণা পরীক্ষা এবং মুডবোর্ড",
          "নতুন সংগ্রহের জন্য শৈলী অন্বেষণ",
          "প্রাক-উৎপাদন পরিকল্পনা সমর্থন"
        ]
      },
      {
        "title": "মেটাডেটার সাথে পেয়ার করুন",
        "paragraphs": [
          "Metadata Studio-এ কীওয়ার্ড-টু-ইমেজ আইডিয়া থেকে ইমেজ-টু-কীওয়ার্ড মেটাডেটাতে যাওয়ার জন্য জেনারেট করা ধারণাগুলি ব্যবহার করুন যাতে উত্পাদন সারিবদ্ধ থাকে।"
        ],
        "bullets": [
          "কীওয়ার্ড অভিপ্রায় সহ প্রম্পট সারিবদ্ধ করুন",
          "প্রি-প্রোডাকশন লেখার সময় বাঁচান",
          "প্রকাশনার প্রস্তুতি ত্বরান্বিত করুন"
        ]
      }
    ],
    "faq": [
      {
        "q": "এটা কি স্টক-প্রস্তুত ছবি তৈরি করে?",
        "a": "এটি রেফারেন্স ভিজ্যুয়াল তৈরি করে। চূড়ান্ত জমা দেওয়ার জন্য প্ল্যাটফর্ম নীতি অনুসরণ করুন।"
      },
      {
        "q": "আমি কি আউটপুট রপ্তানি করতে পারি?",
        "a": "হ্যাঁ। পরিকল্পনা এবং মেটাডেটা প্রস্তুতির জন্য আউটপুট ডাউনলোড করুন।"
      }
    ]
  },
  "/vectorizer": {
    "title": "AI Vectorizer",
    "intro": [
      "স্টক তালিকার জন্য রাস্টার চিত্রগুলিকে পরিষ্কার SVG ভেক্টরে রূপান্তর করুন। ম্যানুয়াল ট্রেসিং টাইম কমান এবং লাইন কোয়ালিটি সামঞ্জস্যপূর্ণ রাখুন।",
      "মার্কেটপ্লেস-প্রস্তুত সম্পদ দ্রুত পাঠানোর জন্য মেটাডেটার পাশাপাশি ভেক্টর আউটপুট ব্যবহার করুন।"
    ],
    "bullets": [
      "দ্রুত রাস্টার থেকে ভেক্টর রূপান্তর",
      "পরিমাপযোগ্য সম্পদের জন্য পাথ পরিষ্কার করুন",
      "ব্যাচ-বন্ধুত্বপূর্ণ কর্মপ্রবাহ"
    ],
    "links": [
      {
        "href": "/metadata",
        "label": "Metadata Studio খুলুন"
      },
      {
        "href": "/pricing",
        "label": "পরিকল্পনা তুলনা করুন"
      },
      {
        "href": "/blog",
        "label": "ভেক্টর ওয়ার্কফ্লো টিপস"
      }
    ],
    "sections": [
      {
        "title": "ভেক্টর আউটপুট পরিষ্কার করুন",
        "paragraphs": [
          "লাইনের গুণমান এবং প্রান্তগুলি সংরক্ষণ করার সময় রাস্টার আর্টওয়ার্ককে SVG- প্রস্তুত সম্পদে রূপান্তর করুন।"
        ],
        "bullets": [
          "ম্যানুয়াল ট্রেসিং সময় কমিয়ে দিন",
          "তালিকার জন্য মাপযোগ্য আউটপুট রাখুন",
          "পরিষ্কার পাথ বজায় রাখুন"
        ]
      },
      {
        "title": "কর্মপ্রবাহ ফিট",
        "paragraphs": [
          "একই সেশনে শিরোনাম এবং কীওয়ার্ড তৈরি করতে Metadata Studio সহ ভেক্টর আউটপুট ব্যবহার করুন।"
        ],
        "bullets": [
          "ব্যাচ-বন্ধুত্বপূর্ণ রূপান্তর",
          "সামঞ্জস্যপূর্ণ ফাইলের নামকরণ",
          "রপ্তানি-প্রস্তুত পাইপলাইন"
        ]
      }
    ],
    "faq": [
      {
        "q": "কি ফরম্যাট সমর্থিত?",
        "a": "সাধারণ রাস্টার ইনপুটগুলি স্টক জমা দেওয়ার জন্য SVG- প্রস্তুত আউটপুটগুলির সাথে সমর্থিত।"
      },
      {
        "q": "ব্যাচ প্রক্রিয়াকরণ উপলব্ধ?",
        "a": OFFER_CONTENT.vectorizerAllowance
      }
    ]
  },
  "/prompter": {
    "title": "Prompter",
    "intro": [
      "সামঞ্জস্যপূর্ণ সম্পদ উত্পাদন এবং মেটাডেটা পরিকল্পনার জন্য কাঠামোগত প্রম্পট তৈরি করুন। আউটপুট পরিষ্কার এবং পুনরায় ব্যবহারযোগ্য রাখতে প্রম্পট টেমপ্লেট ব্যবহার করুন।",
      "আপনার সৃজনশীল অভিপ্রায়ের সাথে মেলে এমন শিরোনাম এবং কীওয়ার্ড তৈরি করতে Metadata Studio-এর সাথে যুক্ত করুন।"
    ],
    "bullets": [
      "টেমপ্লেট-চালিত প্রম্পট কাঠামো",
      "পুনরায় ব্যবহারযোগ্য প্রম্পট লাইব্রেরি",
      "স্টক ধারণার জন্য দ্রুত পুনরাবৃত্তি"
    ],
    "links": [
      {
        "href": "/metadata",
        "label": "মেটাডেটা তৈরি করুন"
      },
      {
        "href": "/pricing",
        "label": "পরিকল্পনা বিকল্প দেখুন"
      },
      {
        "href": "/help",
        "label": "Prompter গাইড"
      }
    ],
    "sections": [
      {
        "title": "স্ট্রাকচার্ড প্রম্পট ডিজাইন",
        "paragraphs": [
          "Prompter আপনাকে ভেরিয়েবলের সাথে পুনরাবৃত্তিযোগ্য প্রম্পট তৈরি করতে সাহায্য করে যাতে আপনার আউটপুটগুলি সামঞ্জস্যপূর্ণ থাকে।"
        ],
        "bullets": [
          "টেমপ্লেট-চালিত প্রম্পট কাঠামো",
          "পুনরায় ব্যবহারযোগ্য প্রম্পট লাইব্রেরি",
          "নতুন ধারণার জন্য দ্রুত পুনরাবৃত্তি"
        ]
      },
      {
        "title": "মেটাডেটার সাথে একত্রিত করুন",
        "paragraphs": [
          "মেটাডেটা ভাষা আপনার সৃজনশীল অভিপ্রায়ের সাথে সারিবদ্ধ রাখতে আপনার প্রম্পট লাইব্রেরি ব্যবহার করুন।"
        ],
        "bullets": [
          "ক্লিনার কীওয়ার্ড সেট",
          "ভাল ধারণা নামকরণ",
          "সামঞ্জস্যপূর্ণ বর্ণনা"
        ]
      }
    ],
    "faq": [
      {
        "q": "আমি কি প্রম্পট টেমপ্লেট সংরক্ষণ করতে পারি?",
        "a": "হ্যাঁ। টেমপ্লেটগুলি প্রকল্প এবং দল জুড়ে পুনরায় ব্যবহার করা যেতে পারে।"
      },
      {
        "q": "এটা কি Metadata Studio এর সাথে কাজ করে?",
        "a": "আউটপুট সারিবদ্ধ রাখতে মেটাডেটা জেনারেশনের পাশাপাশি প্রম্পট ব্যবহার করুন।"
      }
    ]
  },
  "/pricing": OFFER_CONTENT.pricing,
  "/help": {
    "title": "সহায়তা কেন্দ্র",
    "intro": [
      "ওয়ার্কফ্লো গাইড, সেটআপ নির্দেশাবলী এবং সমস্যা সমাধানের পদক্ষেপগুলি খুঁজুন। সহায়তা কেন্দ্র মেটাডেটা, রপ্তানি এবং পরিকল্পনা ব্যবহারের মাধ্যমে চলে।",
      "সাম্প্রতিক আপডেট এবং উন্নতি ট্র্যাক করতে চেঞ্জলগ ব্যবহার করুন।"
    ],
    "bullets": [
      "দ্রুত শুরু ওয়ার্কফ্লো টিউটোরিয়াল",
      "রপ্তানি এবং প্ল্যাটফর্ম সেটআপ গাইড",
      "আপডেট রিলিজ নোট"
    ],
    "links": [
      {
        "href": "/help/changelog",
        "label": "চেঞ্জলগ দেখুন"
      },
      {
        "href": "/metadata",
        "label": "Metadata Studio খুলুন"
      },
      {
        "href": "/blog",
        "label": "ওয়ার্কফ্লো টিপস পড়ুন"
      }
    ],
    "sections": [
      {
        "title": "যা শিখবেন",
        "paragraphs": [
          "গাইড মেটাডেটা জেনারেশন, রপ্তানি, প্ল্যাটফর্ম প্রিসেট এবং সমস্যা সমাধান কভার করে।"
        ],
        "bullets": [
          "মেটাডেটা ওয়ার্কফ্লো সেটআপ",
          "বিন্যাস এবং আপলোড রপ্তানি করুন",
          "অ্যাকাউন্ট এবং বিলিং বেসিক"
        ]
      },
      {
        "title": "জনপ্রিয় শুরুর পয়েন্ট",
        "paragraphs": [
          "Metadata Studio গাইড দিয়ে শুরু করুন, তারপর সর্বশেষ আপডেটের জন্য চেঞ্জলগ পর্যালোচনা করুন।"
        ],
        "bullets": [
          "Metadata Studio ওয়াকথ্রু",
          "প্ল্যাটফর্ম রপ্তানি টিপস",
          "রিলিজ এবং নোট আপডেট"
        ]
      }
    ],
    "faq": [
      {
        "q": "আমি কোথায় শুরু করা উচিত?",
        "a": "Metadata Studio নির্দেশিকা দিয়ে শুরু করুন এবং ধাপে ধাপে ওয়ার্কফ্লো অনুসরণ করুন।"
      },
      {
        "q": "সমর্থন প্রয়োজন?",
        "a": "সহায়তা কেন্দ্র ব্যবহার করুন বা অ্যাপের ভিতর থেকে দলের সাথে যোগাযোগ করুন।"
      }
    ]
  },
  "/help/changelog": {
    "title": "চেঞ্জলগ",
    "intro": [
      "Stocktag-এ সাম্প্রতিক উন্নতি এবং আপডেটগুলি ট্র্যাক করুন৷ প্রতিটি রিলিজ নতুন বৈশিষ্ট্য, সংশোধন, এবং কর্মপ্রবাহের উন্নতি হাইলাইট করে।",
      "নতুন ক্ষমতা ব্যবহার সম্পর্কে গভীর নির্দেশিকাগুলির জন্য সহায়তা কেন্দ্রটি দেখুন৷"
    ],
    "bullets": [
      "সাম্প্রতিক পণ্য আপডেট",
      "বৈশিষ্ট্য উন্নতি এবং সংশোধন",
      "কর্মপ্রবাহের উন্নতি"
    ],
    "links": [
      {
        "href": "/help",
        "label": "সহায়তা কেন্দ্রে ফিরে যান"
      },
      {
        "href": "/blog",
        "label": "ব্লগ আপডেট পড়ুন"
      },
      {
        "href": "/metadata",
        "label": "Metadata Studio খুলুন"
      }
    ],
    "sections": [
      {
        "title": "ট্র্যাক রিলিজ",
        "paragraphs": [
          "প্রতিটি এন্ট্রি নতুন বৈশিষ্ট্য, সংশোধন, এবং কর্মপ্রবাহ আপডেট তালিকাভুক্ত করে যাতে আপনি বর্তমান থাকতে পারেন।"
        ],
        "bullets": [
          "পণ্য উন্নতি",
          "কর্মপ্রবাহের উন্নতি",
          "স্থিতিশীলতা এবং কর্মক্ষমতা সংশোধন"
        ]
      },
      {
        "title": "অবগত থাকুন",
        "paragraphs": [
          "আপনার ওয়ার্কফ্লো আপডেট করার আগে বা নতুন দলের সদস্যদের অনবোর্ড করার আগে সাম্প্রতিক পরিবর্তনগুলি পর্যালোচনা করুন।"
        ],
        "bullets": [
          "আপনার দলের সাথে আপডেট শেয়ার করুন",
          "নতুন রপ্তানি বিকল্পের জন্য চেক করুন",
          "পরিকল্পনা প্রশিক্ষণ সেশন"
        ]
      }
    ],
    "faq": [
      {
        "q": "কত ঘন ঘন এটি আপডেট করা হয়?",
        "a": "আপডেট নতুন রিলিজ জাহাজ হিসাবে পোস্ট করা হয়."
      },
      {
        "q": "আমি কোথায় বৈশিষ্ট্য অনুরোধ করতে পারি?",
        "a": "অ্যাপের ভিতরে বা সহায়তা কেন্দ্রের মাধ্যমে মতামত শেয়ার করুন।"
      }
    ]
  }
};

export const APP_ROUTE_SEO_UI_COPY_BN = {
  "home": "হোম",
  "faq": "সাধারণ প্রশ্ন",
  "summaryTitle": "টিএল; ডিআর",
  "sourcesTitle": "উৎস",
  "sourcesIntro": "এই পৃষ্ঠার উৎসগুলোর মধ্যে নিচে লিঙ্ক করা Stocktag-এর অফিসিয়াল workflow, pricing এবং support পৃষ্ঠা রয়েছে।",
  "relatedLinks": "সম্পর্কিত লিঙ্ক",
  "workflowNotes": "ওয়ার্কফ্লো নোট",
  "depthIntro": (title, keywordSummary) => `এই পৃষ্ঠাটি Stocktag-এর সম্পূর্ণ __bn_param_0__ কর্মপ্রবাহের অংশ যারা অবদানকারীদের স্কেলে নির্ভরযোগ্য আউটপুট প্রয়োজন। এটি ${keywordSummary} এর মতো ব্যবহারিক পদক্ষেপের উপর ফোকাস করে, যাতে দলগুলি মেটাডেটা গুণমান না কমিয়ে দ্রুত প্রকাশ করতে পারে।`,
  "depthBody": "সামঞ্জস্যপূর্ণ ফলাফলের জন্য, এই রুটটিকে Metadata Studio এর সাথে যুক্ত করুন, কীওয়ার্ড অর্ডার ইচ্ছাকৃত রাখুন, এবং এক্সপোর্ট করার আগে একটি ছোট QA পাস চালান৷ এই প্রক্রিয়া Adobe Stock, Shutterstock এবং অন্যান্য মার্কেটপ্লেস জুড়ে আবিষ্কারযোগ্যতা রক্ষা করতে সাহায্য করে।",
  "depthBullets": [
    "শিরোনাম, বর্ণনা এবং কীওয়ার্ডের জন্য পুনরাবৃত্তিযোগ্য টেমপ্লেট ব্যবহার করুন।",
    "রপ্তানির আগে প্রাসঙ্গিকতা যাচাই করুন এবং দুর্বল বা সদৃশ পদগুলি সরান।",
    "কী কাজ করে তা ট্র্যাক করুন এবং আরও ভাল অনুসন্ধানের উদ্দেশ্য সহ পুরানো ফাইলগুলি রিফ্রেশ করুন৷"
  ]
};


export default APP_ROUTE_SEO_CONTENT_BN;
